<template>
  <div class="block-wrap card">
    <div class="card-body">
      <div class="">
        <a
          :href="'//www.animlab.yuntech.edu.tw/talentpool/profile/' + info.id"
          target="_blank"
          ><div
            class="p-img"
            :style="{
              backgroundImage: `url(//www.animlab.yuntech.edu.tw/upload/pool/talent/${info.image})`,
            }"
          ></div>
        </a>
      </div>
      <div class="d-flex">
        <div class="p-tag old-mini">{{ info.year }}年度</div>
        <div class="p-tag old-mini">
          {{ groups[info.group] }}
        </div>
        <!-- <div class="p-tag old-mini">
          {{ info.institute_of_talent.nation }}
        </div>
        <div class="p-tag old-mini">
          {{ info.institute_of_talent.title }}
        </div> -->
      </div>
      <div class="d-flex justify-content-between">
        <div>
          <div class="card-title old-h3-bold">{{ info.name }}</div>
          <div class="card-title old-body">{{ info.title }}</div>
        </div>
        <div class="d-flex align-items-end">
          <a
            :href="'//www.animlab.yuntech.edu.tw/talentpool/profile/' + info.id"
            target="_blank"
            ><img class="link" :src="linkArrow" alt=""
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import linkArrow from '@/assets/img/link_arrow.png';

export default {
  name: 'Participant',
  props: {
    info: { type: Object, required: true },
  },
  data() {
    return {
      linkArrow,
      groups: ['所有組別', '數位動畫組', '視覺傳達設計組', '時尚設計組', '產品設計組', '建築景設組'],
    };
  },
  methods: {

  },
};
</script>

<style lang="stylus" scoped>
.block-wrap
  background: #FFFFFF;
  border: 1px solid #BCB8B1;
  border-radius: 20px;
  min-width: 45%;

.card-body
  padding: 24px;

.card-text
  border-top: 1px solid $monoc4;
  border-bottom: 1px solid $monoc4;
  padding: 16px 0 32px 0;
  margin: 16px 0;
  height: 360px;

.p-img
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  &:after
    content: '';
    display: block;
    padding-bottom: 100%;

.p-tag
  background-color: $monoc4;
  color: $monoc1;
  border-radius: 100px;
  padding: 4px 10px;
  margin: 16px 0;

  + .p-tag
    margin-left: 4px;

img.link
  width: 36px;
</style>
